"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALIGNMENT = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var content_scss_1 = tslib_1.__importDefault(require("./content.scss"));
var withStyles_1 = require("../../../../common/utils/withStyles");
var content_config_1 = require("./content.config");
var ALIGNMENT;
(function (ALIGNMENT) {
    ALIGNMENT["LEFT"] = "left";
    ALIGNMENT["CENTER"] = "center";
    ALIGNMENT["RIGHT"] = "right";
})(ALIGNMENT = exports.ALIGNMENT || (exports.ALIGNMENT = {}));
var Content = /** @class */ (function (_super) {
    tslib_1.__extends(Content, _super);
    function Content() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isClient: false };
        _this.handleContentClick = function (event) {
            var onClick = _this.props.onClick;
            event.preventDefault();
            event.stopPropagation();
            onClick();
        };
        return _this;
    }
    Content.prototype.getStyles = function () {
        var _a = this.props, width = _a.width, isOptimalFontSizes = _a.isOptimalFontSizes, titleFont = _a.titleFont, textFont = _a.textFont;
        return content_config_1.getStyles({ width: width, isOptimalFontSizes: isOptimalFontSizes, titleFont: titleFont, textFont: textFont });
    };
    Content.prototype.componentDidMount = function () {
        if (typeof window !== 'undefined') {
            this.setState({ isClient: true });
        }
    };
    Content.prototype.renderPublisher = function () {
        var _a;
        var _b = this.props, publisher = _b.publisher, isRTL = _b.isRTL, textClassName = _b.textClassName;
        if (!publisher) {
            return null;
        }
        var publisherClassNames = classnames_1.default(content_scss_1.default.publisher, textClassName, (_a = {},
            _a[content_scss_1.default.rtl] = isRTL,
            _a[content_scss_1.default.ltr] = !isRTL,
            _a));
        return (react_1.default.createElement("div", { className: publisherClassNames, "data-hook": "publisher", style: this.getStyles().publisher }, publisher));
    };
    Content.prototype.renderTitle = function () {
        var _a;
        var _b = this.props, title = _b.title, isRTL = _b.isRTL, titleClassName = _b.titleClassName;
        if (!title) {
            return null;
        }
        var titleClassNames = classnames_1.default(content_scss_1.default.title, titleClassName, (_a = {},
            _a[content_scss_1.default.rtl] = isRTL,
            _a[content_scss_1.default.ltr] = !isRTL,
            _a));
        return (react_1.default.createElement("h3", { key: this.state.isClient ? 'title-client' : 'title-ssr', className: titleClassNames, title: title, style: this.getStyles().title, "data-hook": "title" }, title));
    };
    Content.prototype.renderDescription = function () {
        var _a;
        var _b = this.props, description = _b.description, isRTL = _b.isRTL, textClassName = _b.textClassName;
        if (!description) {
            return null;
        }
        var descriptionClassNames = classnames_1.default(content_scss_1.default.description, textClassName, (_a = {},
            _a[content_scss_1.default.rtl] = isRTL,
            _a[content_scss_1.default.ltr] = !isRTL,
            _a));
        return (react_1.default.createElement("div", { key: this.state.isClient ? 'description-client' : 'description-ssr', className: descriptionClassNames, "data-hook": "description", style: this.getStyles().description }, description));
    };
    Content.prototype.render = function () {
        var _a, _b;
        var _c = this.props, className = _c.className, isFocusable = _c.isFocusable, alignment = _c.alignment, isRTL = _c.isRTL;
        var containerClassNames = classnames_1.default(content_scss_1.default.container, (_a = {},
            _a[content_scss_1.default['align-left']] = alignment === ALIGNMENT.LEFT,
            _a[content_scss_1.default['align-center']] = alignment === ALIGNMENT.CENTER,
            _a[content_scss_1.default['align-right']] = alignment === ALIGNMENT.RIGHT,
            _a[content_scss_1.default.rtl] = isRTL,
            _a[content_scss_1.default.ltr] = !isRTL,
            _a));
        var contentClassNames = classnames_1.default(content_scss_1.default.content, className, (_b = {},
            _b[content_scss_1.default.rtl] = isRTL,
            _b[content_scss_1.default.ltr] = !isRTL,
            _b));
        return (react_1.default.createElement("div", { className: containerClassNames },
            react_1.default.createElement("a", { href: "#", className: contentClassNames, onClick: this.handleContentClick, tabIndex: isFocusable ? 0 : -1, "aria-hidden": !isFocusable, style: this.getStyles().content },
                this.renderPublisher(),
                this.renderTitle(),
                this.renderDescription())));
    };
    Content.defaultProps = {
        alignment: ALIGNMENT.LEFT,
        isOptimalFontSizes: true,
    };
    Content = tslib_1.__decorate([
        withStyles_1.withStyles(content_scss_1.default)
    ], Content);
    return Content;
}(react_1.default.Component));
exports.default = Content;
//# sourceMappingURL=content.js.map